/**
 * Scorecard Routes
 * legacy app: canActivate: [AuthGuard, VendorRoleGuard, RoleGuard]
 * data: { checkRoleFor: 'UHCI_SCORE_CARD' }
 */
import React, { lazy } from 'react';
import { RouteConfig, RouteMetadata } from '../../types';

const RouteFrameStyles: React.CSSProperties = {
  width: '60rem',
  maxWidth: '100%',
  margin: '0 auto',
  boxSizing: 'border-box',
};

const NetworkManagementRouteFrame: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <div style={RouteFrameStyles}>{children}</div>
);

const Scorecard = lazy(() =>
  import('@src/apps/Scorecard/Scorecard').then(m => ({ default: m.Scorecard }))
);
const Heatmap = lazy(() =>
  import('@src/apps/Heatmap/Heatmap').then(m => ({ default: m.Heatmap }))
);

const EXTERNAL_ACCESS_DENIED: Pick<RouteMetadata, 'externalAccess'> = {
  externalAccess: false,
};

const SCRoute = () => (
  <NetworkManagementRouteFrame>
    <Scorecard />
  </NetworkManagementRouteFrame>
);

export const scorecardRoutes: RouteConfig[] = [
  {
    path: 'scorecard',
    component: SCRoute,
    guards: ['auth', 'vendor', 'role'],
    data: {
      ...EXTERNAL_ACCESS_DENIED,
      title: 'Contract Intelligence',
      breadcrumb: 'Scorecard',
      preload: false,
      delay: true,
      checkRoleFor: 'UHCI_SCORE_CARD',
    },
  },
  {
    path: 'scorecard/heatmap',
    component: Heatmap,
    guards: ['auth', 'role', 'vendor'],
    data: {
      ...EXTERNAL_ACCESS_DENIED,
      title: 'Contract Intelligence - Heatmap',
      breadcrumb: 'Heatmap',
      preload: false,
      delay: true,
      checkRoleFor: 'UHCI_SCORE_CARD',
    },
  },
];

